module.exports = __webpack_public_path__ + "img/logo-500.d698b9de.png";